require('ionic')
require('ionic-angular')
require('js/filters/module')
require('js/services/module')
require('js/directives/module')
require('js/controllers/module')
require('js/user/User')
require('js/skin')
require('js/login/module')
require('js/mail/module')
require('js/netFolder/module')
require('js/schedule/module')
require('js/setting/module')
require('js/verification/module')
require('js/addressbook/organizational/contact/module')
require('js/addressbook/organizational/detail/module')
require('js/addressbook/organizational/detail/avatarDirectives')
require('js/infrastructure/module')
require('js/infrastructure/utils/module')
require('js/infrastructure/i18n/module')
require('js/animations')
require('angular-cookies')
require('angular-translate')
require('angular-translate-loader-static-files')
require('angular-translate-storage-cookie')
require('angular-translate-storage-local')
require('angular-elastic')
require('angular-sanitize')
require('angular-animate')
require('angular-ui-router')
require('ngtouch')
const angular = require('angular')

// Disabling Ionic's keyboard adjustments.
const interval = setInterval(_ => {
  if (window.ionic.keyboard.isInitialized) {
    window.ionic.keyboard.disable()
    clearInterval(interval)
  }
}, 1000)

// CIM-26995 tap点击一次触发2次问题(https://cdn.bootcdn.net/ajax/libs/ionic/1.3.2/js/ionic.js 967行)
window.ionic.Gestures.NO_MOUSEEVENTS = window.ionic.Gestures.HAS_TOUCHEVENTS

// 声明应用
const app = angular.module('hxphone', [
  // 系统默认服务
  'ui.router',
  'ngCookies',
  'ngSanitize',
  'ngAnimate',
  'pascalprecht.translate',
  'monospaced.elastic',
  // 自定义注入
  'hxphone.controllers',
  'hxphone.filters',
  'hxphone.services',
  'hxphone.directives',
  'hxphone.animations',
  'hxphone.utils',
  'hxphone.infrastructure',
  'hxphone.compose',
  'hxphone.contactList',
  'hxphone.detail',
  'hxphone.avatarDirectives',
  'hxphone.netFolder',
  'hxphone.schedule',
  'hxphone.setting',
  'hxphone.verification',
  'hxphone.mail',
  'hxphone.login',
  'hxphone.language',
  'ionic',
  'hxphone.user',
  'hxphone.skin',
  'ngTouch'
])
app.run([
  '$templateCache',
  function ($templateCache) {
    // http://stackoverflow.com/questions/33436729/webpack-using-require-for-ng-include
    // Put in cache the files that are ng-include'd in templates
    $templateCache.put('views/mail/folders.html', require('views/mail/folders.html'))
    $templateCache.put('views/mail/mailbox-accounts.html', require('views/mail/mailbox-accounts.html'))
    $templateCache.put('views/compose/composeContent.html', require('views/compose/composeContent.html'))
    $templateCache.put('views/mail/messages.html', require('views/mail/messages.html'))
    $templateCache.put('views/mail/read-content.html', require('views/mail/read-content.html'))
    $templateCache.put('views/compose/attachment.html', require('views/compose/attachment.html'))
    $templateCache.put('views/addressBook/contactTopDisplayUser.html', require('views/addressBook/contactTopDisplayUser.html'))
    $templateCache.put('views/addressBook/selectContactTopDisplayUser.html', require('views/addressBook/selectContactTopDisplayUser.html'))
  }
])

app.run(['$state', '$ionicHistory', '$rootScope', 'LocalStorage', '$ionicViewSwitcher', '$utils', function($state, $ionicHistory, $rootScope, LocalStorage, $ionicViewSwitcher, $utils) {
  // 手动设置切换页面动画规则
  const setSwitchAnimationRule = function(toState, toParams, fromState, fromParams) {
    const storeStateList = [
      'frame.read',
      'frame.contactList'
    ]

    /**
     * store back state in local storage for addressbook detail page
     *
     * contactList -> detail
     * read -> detail
     */
    storeStateList.indexOf(toState.name) > -1 && LocalStorage.setItem('detailBack', toState.name + '(' + JSON.stringify(toParams) + ')')
    const backStateListForPabDetail = [
      'frame.personalContactList',
      'frame.read',
      'frame.personalContact',
      'frame.contactList',
    ]
    /**
     * store back state in local storage for addressbook detail page
     *
     * contactList -> detail
     * read -> detail
     */
    backStateListForPabDetail.indexOf(toState.name) > -1 && LocalStorage.setItem('personalDetailBack', toState.name + '(' + JSON.stringify(toParams) + ')')
    /**
     * store back state in local storage for addressbook createContact page
     *
     * frame.detail -> frame.contact
     */
    const backStateListForCreateContact = [
      'frame.detail',
      'frame.personalContact',
      'frame.personalContactDetail',
    ]
    backStateListForCreateContact.indexOf(fromState.name) > -1 && LocalStorage.setItem('createContactBack', fromState.name + '(' + JSON.stringify(fromParams) + ')')
    const manualSwitchStateList = [
      'frame.read',
      'frame.detail',
      'frame.contactList',
      'frame.nfList',
      'frame.netFolder',
      'frame.maildealings',
      'frame.createContact',
      'frame.createGroup',
      'frame.personalContact',
      'frame.personalContactList',
      'frame.personalContactDetail',
      'frame.languageSetup',
      'frame.setting',
    ]

    /**
     * 手工设置 animation 方向
     * set switching direction manually
     * https://forum.ionicframework.com/t/setting-the-transition-direction-animation/541/29
     *
     *  read
     *   |
     * detail -- maildealings
     *   |
     * contactList -> contactList
     *     |
     * netFolder -> nfList -> nfList
     */
    manualSwitchStateList.indexOf(fromState.name) > -1 && (function () {
      if (fromState.name !== toState.name) {
        /** nfList -> netFolder: back */
        /** detail -> contactList: back */
        /** detail -> read: back */
        /** maildealings -> detail: back */
        if ((fromState.name === 'frame.nfList' && toState.name === 'frame.netFolder') ||
          (fromState.name === 'frame.detail' && toState.name === 'frame.contactList') ||
          (fromState.name === 'frame.detail' && toState.name === 'frame.personalContact') ||
          (fromState.name === 'frame.read' && toState.name === 'frame.folder') ||
          (fromState.name === 'frame.personalContact' && toState.name === 'frame.contactList') ||
          (fromState.name === 'frame.personalContactList' && toState.name === 'frame.personalContact') ||
          (fromState.name === 'frame.detail' && toState.name === 'frame.read') ||
          (fromState.name === 'frame.personalContactDetail' && toState.name === 'frame.personalContactList') ||
          (fromState.name === 'frame.personalContactDetail' && toState.name === 'frame.personalContact') ||
          (fromState.name === 'frame.createContact' && toState.name === 'frame.personalContact') ||
          (fromState.name === 'frame.createGroup' && toState.name === 'frame.personalContact') ||
          (fromState.name === 'frame.createGroup' && toState.name === 'frame.personalContactList') ||
          (fromState.name === 'frame.createContact' && toState.name === 'frame.personalContactList') ||
          (fromState.name === 'frame.createContact' && toState.name === 'frame.personalContactDetail') ||
          (fromState.name === 'frame.personalContactDetail' && toState.name === 'frame.read') ||
          (fromState.name === 'frame.languageSetup' && toState.name === 'frame.setting') ||
          (fromState.name === 'frame.sharedMailbox' && toState.name === 'frame.setting') ||
          (fromState.name === 'frame.changePassword' && toState.name === 'frame.setting') ||
          (fromState.name === 'frame.personalContactDetail' && toState.name === 'frame.contactList') ||
          (fromState.name === 'frame.maildealings' && toState.name === 'frame.detail')) {
          $ionicViewSwitcher.nextDirection(['back'])
          return
        }

        /** netFolder -> nfList: forward */
        /** contactList -> detail: forward */
        /** personalContact -> detail: forward */
        /** read -> detail: forward */
        /** detail -> maildealings: forward */
        if ((fromState.name === 'frame.netFolder' && toState.name === 'frame.nfList') ||
          (fromState.name === 'frame.contactList' && toState.name === 'frame.personalContact') ||
          (fromState.name === 'frame.personalContact' && toState.name === 'frame.personalContactList') ||
          (fromState.name === 'frame.personalContactList' && toState.name === 'frame.detail') ||
          (fromState.name === 'frame.personalContact' && toState.name === 'frame.createContact') ||
          (fromState.name === 'frame.personalContactList' && toState.name === 'frame.createGroup') ||
          (fromState.name === 'frame.personalContact' && toState.name === 'frame.createGroup') ||
          (fromState.name === 'frame.personalContactList' && toState.name === 'frame.personalContactDetail') ||
          (fromState.name === 'frame.personalContact' && toState.name === 'frame.personalContactDetail') ||
          (fromState.name === 'frame.detail' && toState.name === 'frame.createContact') ||
          (fromState.name === 'frame.contactList' && toState.name === 'frame.detail') ||
          (fromState.name === 'frame.read' && toState.name === 'frame.detail') ||
          (fromState.name === 'frame.contactList' && toState.name === 'frame.personalContactDetail') ||
          (fromState.name === 'frame.personalContactDetail' && toState.name === 'frame.maildealings') ||
          (fromState.name === 'frame.read' && toState.name === 'frame.personalContactDetail') ||
          (fromState.name === 'frame.personalContactDetail' && toState.name === 'frame.createContact') ||
          (fromState.name === 'frame.setting' && toState.name === 'frame.languageSetup') ||
          (fromState.name === 'frame.setting' && toState.name === 'frame.sharedMailbox') ||
          (fromState.name === 'frame.setting' && toState.name === 'frame.changePassword') ||
          (fromState.name === 'frame.contactList' && toState.name === 'frame.personalContactDetail') ||
          (fromState.name === 'frame.folder' && toState.name === 'frame.compose') ||
          (fromState.name === 'frame.detail' && toState.name === 'frame.maildealings')) {
          $ionicViewSwitcher.nextDirection(['forward'])
          return
        }

        /** contactList -> netFolder: none */
        /** netFolder -> contactList: none */
        $ionicViewSwitcher.nextDirection(['none'])
      }

      /** set direction only there is path in the state parameters */
      // toParams.path && $ionicViewSwitcher.nextDirection([toParams.path.length > fromParams.path.length ? 'forward' : 'back'])
    })()

    /** 在切换状态时需要通过 `updatePositions()` 的调用去重置 ionic 对标题状态的记忆 */
    /** reset titleLeft and titleRight by calling `updatePositions()` of $ionHeaderBarController */
    const headerBarElements = document.querySelectorAll('ion-header-bar')
    for (let i = 0, len = headerBarElements.length; i < len; i++) {
      const ctrl = angular.element(headerBarElements[i]).data().$ionHeaderBarController
      ctrl.updatePositions(headerBarElements[i], 0, 0, 0, 0, '', false)
    }

    angular.element(document.getElementsByClassName('popover-backdrop')).triggerHandler('click')
  }

  // 视图切换触发器：浏览器(navigator) 应用程序(app)
  let SWITCHTRIGGER = 'navigator'

  // 由于无法判断用户是通过浏览器触发的，因此只能给客户端触发添加标记
  const setSwitchTrigger = function() {
    const originFn = {
      stateGo: $state.go,
      ionicHistoryGoBack: $ionicHistory.goBack,
      history: {
        go: history.go,
        back: history.back,
        forward: history.forward
      }
    }
    $state.go = function() {
      SWITCHTRIGGER = 'app'
      originFn.stateGo.apply($state, [...arguments])
    }
    $ionicHistory.goBack = function() {
      SWITCHTRIGGER = 'app'
      originFn.ionicHistoryGoBack.apply($ionicHistory, [...arguments])
    }
    angular.forEach(Object.keys(originFn.history), item => {
      history[item] = function() {
        SWITCHTRIGGER = 'app'
        originFn.history[item].apply(history, [...arguments])
      }
    })
  }

  setSwitchTrigger()

  $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {
    if (SWITCHTRIGGER === 'navigator') {
      // 禁止动画
      $ionicViewSwitcher.nextDirection(['none'])
    } else {
      // 展示动画
      setSwitchAnimationRule(toState, toParams, fromState, fromParams)
      SWITCHTRIGGER = 'navigator'
    }
  })
}])

module.exports = app



// WEBPACK FOOTER //
// ./src/js/app.js